export function log_params(params, base_url = "") {
  // Convert params object to a query string
  const queryString = Object.keys(params)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
    )
    .join("&");

  // Construct the full URL with query string
  const fullUrl = `${base_url}?${queryString}`;

  console.log("Full URL:", fullUrl);
}
